const txt = [
  ["Ты шутишь со мной?", "Are you kidding with me?"],
  [
    "это не может случиться. Ты врешь.",
    "This cannot be happening. You are lying.",
  ],
  [
    "я хотел сказать тебе в первую очередь",
    "I wanted to tell you at the first place.",
  ],
  [
    "не драматизируй, я знаю, что она здесь",
    "Don't be so dramatic. I know she is here",
  ],
  ["Почему ты так переживаешь?", "Why are you so worried?"],
  ["Почему бы тебе не позвонить ей?", "Why don't you ring her up?"],
  ["Почему она наврала мне?", "Why did she lie to me?"],
  ["Давай, папа. Возьми трубку.", "Come on dad. Pick up the phone."],
  [
    "Что ты имеешь в виду? Что тут происходит?",
    "What do you mean? What is going on here?",
  ],
  ["зачем ты хочешь видеть моего отца?", "Why do you want to meet my dad?"],
  ["тебе нужно найти собственную дочь", "You should find your own daughter"],
  ["моя дочь с твоим отцом", "My daughter is with your dad."],
  ["что ты хочешь сказать?", "What do you want to say"],
];

export default txt;
